export default __webpack_public_path__ + "fd0e84405d9dd4cce3798012337fb479.svg";